import React from 'react'
import "./Projects.scss"
import { FiGithub } from 'react-icons/fi'
import { BiLinkExternal } from 'react-icons/bi'
import projects from './projectsData';
import { motion } from "framer-motion"
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

export const Projects = () => {

  const Arrow = (props) => {
    const { className, style, onClick } = props;
    return (
      <div
        className={className}
        style={{ ...style, display: "none" }}
        onClick={onClick}
      />
    );
  }

  const sliderSettings = {
    dots: true,
    infinite: false,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    nextArrow: <Arrow />,
    prevArrow: <Arrow />
  };

  return (
    <div className="projects flex container">
        <motion.h1
            initial={{ y: '100%' }}
            animate={{ y: 0 }}
            transition={{ duration: 0.2, ease: 'easeOut' }}
            className="title">
              My Projects Highlight
          </motion.h1>
          <div className="content-container">
            <Slider {...sliderSettings}>
                {projects.map((project, index) => {
                  return (
                      <motion.div
                        initial={{ y: '100%' }}
                        animate={{ y: 0 }}
                        transition={{ duration: 0.2, ease: 'easeOut' }}
                        className="project-description" key={index}>
                          <div className={`images-container ${project.isInProgress ? 'in-progress' : ''}`}>
                            <img src={project.image != "" ? project.image : "https://quixy.com/wp-content/uploads/2020/06/Blog_The-future-of-software-is-no-code_Cloud-disruption-has-made-technology-accessible-to-all.png"} alt='' className='project-image'/>
                          </div>
                          <div className="description-container">
                              <h2 className='name'>{project.projectName}</h2>
                              <p className='description'>{project.description}</p>
                              <div className="skills">
                                <ul className='list'>
                                    {project.skills.map((skill, index) => (
                                        <li className='skill' key={index}>{skill}</li>
                                    ))}
                                </ul>
                              </div>
                              <div className="links flex">
                                  <a href={project.github} target="_blank" rel="noreferrer"><FiGithub className='icon' /></a>
                                  <a href={project.source} target="_blank" rel="noreferrer"><BiLinkExternal className='icon' /></a>
                              </div>
                          </div>
                      </motion.div>
                  );
                })}
            </Slider>
          </div>
    </div>
  )
}